import { PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';

type Props = PropsWithChildren<{
    onClick(): void;
    disabled?: boolean;
}>;

export const DropdownItem = ({ onClick, disabled, children }: Props) => {
    return (
        <Container onClick={onClick} type="button" disabled={disabled}>
            {children}
        </Container>
    );
};

const Container = styled('button')<{ isSelected?: boolean }>(({ theme, isSelected = false }) => ({
    all: 'unset',
    background: theme.palette.semantic.bg.default,
    border: 'none !important',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 6px',
    cursor: 'pointer',
    borderBottom: '1px solid currentColor',
    color: theme.palette.semantic.bg.brand,
    fontFeatureSettings: "'liga' off",
    /* Typescale/Normal/text-sm.normal */
    fontFamily: '"TT Commons Pro"',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--Font-Line-height-leading-4, 19px)', /* 135.714% */
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',

    ':hover, :focus': {
        background: theme.palette.semantic.int.hover
    },
    ':active': {
        background: theme.palette.semantic.int.hover
    },
    ':disabled': {
        cursor: 'not-allowed',
        color: theme.palette.semantic.int.disabled2,
        background: 'transparent'
    },
    ':first-of-type': {
        borderRadius: '6px 6px 0 0'
    },
    ':last-child': {
        borderRadius: '0 0 6px 6px'
    },
    ':only-child': {
        borderRadius: '6px'
    },
    ...(isSelected && {
        background: theme.palette.primary[100]
    }),
    '> svg': {
        width: 16,
        height: 16,
        marginRight: 12
    }
}));
